import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const OfferContext = createContext();

export const useOffer = () => {
  const context = useContext(OfferContext);
  if (!context) {
    throw new Error('useOffer must be used within OfferProvider');
  }
  return context;
};

export const OfferProvider = ({ children }) => {
  const { slug } = useParams();
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOffer = async () => {
      try {
        // PUBLIC endpoint - no token required for viewing offer
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/offers/${slug}`
        );
        setOffer(response.data);
        
        // Increment view count (also public)
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/offers/${slug}/view`
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchOffer();
    }
  }, [slug]);

  return (
    <OfferContext.Provider value={{ offer, loading, error }}>
      {children}
    </OfferContext.Provider>
  );
};
